var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmailIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 213,
    viewBox: "0 0 293 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0064 135.23L57.7073 150.829L45.745 141.512L0 124.985L52.0064 135.23Z",
    fill: "#FFCE7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.0064 135.23L57.7073 150.829L45.745 141.512L0 124.985L52.0064 135.23Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.21 145.147L57.7075 150.828L45.7451 141.512L44.21 145.147Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.745 141.512L0 124.985L37.5171 161.468L45.745 141.512Z",
    fill: "#FFCE7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0065 135.23L71.0237 123L0 124.985L52.0065 135.23Z",
    fill: "#FFCE7A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8936 148.624C65.9053 153.102 76.7762 162.587 86.5464 170.661C100.221 181.961 113.974 192.945 130.083 200.7C159.436 214.83 194.392 217.128 222.568 199.377C230.087 194.64 236.539 188.627 240.214 180.373C244.915 169.816 242.284 158.819 237.445 148.817C227.032 127.295 209.619 113.65 190.108 101",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.871 129.602H94.8218V38.5194L148.838 4.33105L202.871 38.5194V129.602Z",
    fill: "#FFCE7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M202.871 129.602H94.8218V38.5194L148.838 4.33105L202.871 38.5194V129.602Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.782 122.633H100.911V0H172.098L196.782 23.368V122.633Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.098 0L196.781 23.368H172.098V0Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.264 23.7295L163.564 23.7295V20.5839L110.264 20.5839V23.7295Z",
    fill: "#DBDBDB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.264 31.6748L163.564 31.6748V28.5293L110.264 28.5293V31.6748Z",
    fill: "#DBDBDB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.264 39.6211L163.564 39.6211V36.4756L110.264 36.4756V39.6211Z",
    fill: "#DBDBDB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 47.5674L188.358 47.5674V44.4218L110.262 44.4218V47.5674Z",
    fill: "#DBDBDB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 55.5225L188.358 55.5225V52.3769L110.262 52.3769V55.5225Z",
    fill: "#DBDBDB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 63.4687L188.358 63.4688V60.3233L110.262 60.3233V63.4687Z",
    fill: "#DBDBDB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 71.415L188.358 71.415V68.2695L110.262 68.2695V71.415Z",
    fill: "#DBDBDB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 79.3613L188.358 79.3613V76.2158L110.262 76.2158V79.3613Z",
    fill: "#DBDBDB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 87.3086L188.358 87.3086V84.1631L110.262 84.1631V87.3086Z",
    fill: "#DBDBDB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 95.2637L188.358 95.2637V92.1181L110.262 92.1181V95.2637Z",
    fill: "#DBDBDB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 103.209L188.358 103.209V100.063L110.262 100.063V103.209Z",
    fill: "#DBDBDB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.262 111.155L188.358 111.155V108.01L110.262 108.01V111.155Z",
    fill: "#DBDBDB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.871 61.3203V129.602H94.8218V61.3203C99.4618 63.9416 104.024 66.6918 108.613 69.3732C113.192 72.1062 117.763 74.8392 122.308 77.6238C127.371 80.692 132.434 83.8203 137.479 86.9658C137.531 86.9315 137.591 86.8971 137.643 86.8713C137.591 86.9057 137.565 86.9486 137.514 86.983C141.291 89.3293 145.077 91.6841 148.855 94.0476C152.624 91.6841 156.402 89.3121 160.179 86.983C160.127 86.9486 160.102 86.9057 160.05 86.8713C160.102 86.9057 160.162 86.94 160.214 86.9486C165.259 83.8117 170.304 80.692 175.384 77.6066C179.93 74.8392 184.483 72.089 189.063 69.3732C193.677 66.6832 198.231 63.933 202.871 61.3203Z",
    fill: "#FFCE7A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M202.871 61.3211C198.507 64.3807 194.056 67.3028 189.667 70.3108C185.233 73.2501 180.792 76.1979 176.324 79.1028C171.667 82.1452 166.992 85.1532 162.318 88.1441C162.171 88.2386 162.042 88.3417 161.895 88.4363C157.755 91.0747 153.607 93.7046 149.45 96.3431L148.838 96.7126L148.234 96.3431C144.077 93.7046 139.946 91.0747 135.806 88.4191C135.659 88.3417 135.513 88.2386 135.366 88.1441C130.674 85.1532 126 82.1452 121.342 79.0856C116.892 76.1893 112.45 73.2501 108.017 70.3022C103.619 67.2942 99.177 64.3721 94.813 61.3125C99.453 63.9338 104.015 66.684 108.604 69.3654C113.183 72.0984 117.754 74.8314 122.3 77.616C127.362 80.6842 132.425 83.8125 137.47 86.9581C137.488 86.9581 137.488 86.958 137.505 86.9752C141.282 89.3215 145.069 91.6763 148.846 94.0398C152.615 91.6763 156.393 89.3043 160.17 86.9752C160.188 86.9409 160.188 86.9409 160.205 86.9409C165.25 83.8039 170.296 80.6842 175.376 77.5988C179.921 74.8314 184.475 72.0812 189.054 69.3654C193.677 66.684 198.231 63.9338 202.871 61.3211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.644 86.8633C137.592 86.8977 137.566 86.9406 137.515 86.975C136.945 87.4563 136.376 87.9462 135.807 88.4103C133.099 90.6878 130.322 92.8707 127.501 94.9935C124.06 97.6148 120.541 100.116 117.005 102.608C113.452 105.049 109.881 107.473 106.233 109.802C102.585 112.131 98.9022 114.408 95.0815 116.497C98.3589 113.635 101.766 110.97 105.207 108.366C108.665 105.745 112.184 103.244 115.703 100.752C119.274 98.2938 122.844 95.8701 126.492 93.5411C129.399 91.6847 132.349 89.8541 135.367 88.1438C136.066 87.7399 136.764 87.3532 137.48 86.9664C137.532 86.932 137.592 86.8977 137.644 86.8633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M202.612 116.505C198.8 114.417 195.1 112.139 191.461 109.81C187.812 107.481 184.242 105.058 180.671 102.617C177.135 100.125 173.616 97.6236 170.175 95.0023C167.363 92.8881 164.595 90.7137 161.895 88.4362C161.309 87.955 160.74 87.4651 160.179 86.9838C160.127 86.9494 160.102 86.9064 160.05 86.8721C160.102 86.9064 160.162 86.9408 160.214 86.9494C160.93 87.3534 161.628 87.7401 162.327 88.144C165.345 89.8543 168.278 91.6849 171.201 93.5413C174.85 95.8703 178.42 98.2939 181.974 100.752C185.51 103.244 189.029 105.745 192.47 108.367C195.928 110.971 199.335 113.643 202.612 116.505Z",
    fill: "black"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M243.908 16.1301L238.889 31.067L250.006 21.9312L293 5.10352L243.908 16.1301Z",
    fill: "#6A75CA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M243.908 16.1301L238.889 31.067L250.006 21.9312L293 5.10352L243.908 16.1301Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M251.558 25.3426L238.889 31.0664L250.006 21.9307L251.558 25.3426Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250.006 21.9312L293 5.10352L258.32 40.6669L250.006 21.9312Z",
    fill: "#6A75CA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M243.908 16.1297L225.555 5L293 5.10313L243.908 16.1297Z",
    fill: "#6A75CA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M242.567 29C233.957 33.8397 226.284 40.1192 218.448 46.1007C204.952 56.4016 191.647 66.9615 177.39 76.2044C159.949 87.5122 140.925 97.3247 120.264 100.952C95.1346 105.364 59.2211 91.548 54.4431 63.2014C52.7781 53.3236 54.7128 45.7826 62.7834 39.5508C69.484 34.3769 76.8814 31.5371 85.357 32.033C90.0671 32.3085 94.0887 33.7139 98.4632 35.324",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailIllustration);
export default __webpack_public_path__ + "static/media/sendEmailIllustration.d12c2309e37659a6001e319621a5bc6e.svg";
export { ForwardRef as ReactComponent };